import './App.css';
import "./index.css";
import Routing from "./config/routes";
function App() {
  return (
    <div>
      <Routing />
    </div>
  );
}
export default App;